<template>
  <div>
    <vx-card title="Perbarui Data" subtitle="Isi data dengan benar">
      <template slot="actions">
          <div class="vx-row">
            <div class="vx-col w-full m-0">
              <vs-button icon-pack="feather" class="mt-2" @click="saveCashFlow()">Simpan Data</vs-button>
              <vs-button @click="goBack" class="ml-4 mt-2" type="border" color="danger">Kembali</vs-button>
            </div>
          </div>
      </template>
      <div slot="no-body" class="p-6">
          <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">

          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <div class="w-full mt-4">
                <label class="text-sm opacity-75">Jenis Kas</label>
                <ul class="centerx vx-row">
                  <li class="m-3">
                    <vs-radio vs-value="debit" v-model="type">Kas Masuk</vs-radio>
                  </li>
                  <li class="m-3">
                    <vs-radio vs-value="credit" v-model="type">Kas Keluar</vs-radio>
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="w-full mt-4">
                <label class="text-sm opacity-75">Tanggal</label>
                <vs-input class="w-full" v-mask="'##-##-####'" v-model="date" v-validate="'required'" name="date" disabled />
                <span class="text-danger text-sm"  v-show="errors.has('date')">{{ errors.first('date') }}</span>
              </div>
            </div>
            <!-- <div class="vx-col md:w-1/2 w-full">
              <vs-input class="w-full mt-4" label="Nomor" v-model="number" v-validate="'required|numeric'" name="number" />
              <span class="text-danger text-sm"  v-show="errors.has('number')">{{ errors.first('number') }}</span>
            </div> -->
          </div>

          <div class="vx-row mt-2">
            <div class="vx-col w-full">
              <label class="text-sm opacity-75">Dibayarkan kepada</label>
              <vs-input class="w-full" v-model="paidTo" v-validate="'required'" name="paidTo" />
              <span class="text-danger text-sm"  v-show="errors.has('paidTo')">{{ errors.first('paidTo') }}</span>
            </div>
            <!-- <div class="vx-col md:w-1/2 w-full">
              <label class="text-sm opacity-75">Jumlah</label>
              <vs-input class="w-full" v-model="amount" v-validate="'required'" name="amount" />
              <span class="text-danger text-sm"  v-show="errors.has('amount')">{{ errors.first('amount') }}</span>
            </div> -->
          </div>

          <div class="vx-row mt-2">
            <div class="vx-col w-full">
              <label class="text-sm opacity-75">Catatan</label>
              <vs-textarea class="w-full" v-model="notes" v-validate="'required'" name="notes" />
              <span class="text-danger text-sm"  v-show="errors.has('notes')">{{ errors.first('notes') }}</span>
            </div>
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <vs-row class="mt-4">
            <vs-col class="px-1" vs-sm="12" vs-lg="7">
              <label class="text-sm opacity-75">Keterangan</label>
            </vs-col>
            <vs-col vs-sm="12" vs-lg="5">
              <vs-row>
                <vs-col class="px-1" vs-sm="12" vs-lg="10">
                  <label class="text-sm opacity-75">Total</label>
                </vs-col>
                <vs-col class="px-1" vs-sm="12" vs-lg="2">
                  &nbsp;
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
          <template>
            <vs-row class="mb-2" v-for="(input, i) in inputs" :key="i">
                <vs-col class="px-1" vs-sm="12" vs-lg="7">
                  <vs-input
                    class="w-full"
                    v-model="input.title"
                    name="input.title"
                    placeholder="Write here"
                  />
                </vs-col>
                <vs-col vs-sm="12" vs-lg="5">
                  <vs-row>
                    <vs-col class="px-1 w-full md:w-10/12">
                      <vs-input
                        class="w-full"
                        v-model="input.amount"
                        type="number"
                        min="0"
                        name="input.amount"
                        v-on:change="amountChange(i)"
                      />
                    </vs-col>
                    <vs-col class="px-1" vs-sm="12" vs-lg="2">
                      <vs-button
                        class="w-full"
                        color="danger"
                        type="filled"
                        icon-pack="feather"
                        v-if="inputs.length > 1"
                        icon="icon-trash"
                        @click="remove(i)"
                      ></vs-button>
                    </vs-col>
                  </vs-row>
                </vs-col>
            </vs-row>
          </template>
          <div class="mt-4 px-1">
            <vs-button class="w-full" color="success" type="filled" icon-pack="feather" icon="icon-plus" @click="add()">Tambah</vs-button>
          </div>
          <div class="mt-4 px-1">
            Total : {{amount.toLocaleString()}}
          </div>
        </div>
      </div>
    </div>
  </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import { VMoney } from 'v-money'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// Store Module
import moduleCashFlow from '@/store/cashflows/moduleCashFlow.js'

import { quillEditor } from 'vue-quill-editor'

const toolbarOptions = [
  ['bold', 'italic', 'underline'],        // toggled buttons

  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
  [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

  [{ 'font': [] }],
  [{ 'align': [] }]                                 // remove formatting button
]

export default {
  components: {
    vSelect,
    Datepicker,
    quillEditor
  },
  directives: { money: VMoney },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.hasPreviousRoute = Boolean(
        from &&
        from.name &&
        from.matched &&
        from.matched.some(route => route.meta && route.meta.authRequired)
      )
    })
  },
  data () {
    return {
      editorOption: {
        modules: {
          toolbar: toolbarOptions
        }
      },
      cashbook_id: null,
      type: null,
      paidTo: null,
      date: null,
      debit: null,
      credit: null,
      amount: 0,
      notes: null,
      hasPreviousRoute: false,
      inputs: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false /* doesn't work with directive */
      }
    }
  },
  created () {
    if (!moduleCashFlow.isRegistered) {
      this.$store.registerModule('cashFlow', moduleCashFlow)
      moduleCashFlow.isRegistered = true
    }
    this.findCashFlow()
  },
  watch: {
    inputs: {
      handler (inputs) {
        this.amount = inputs
          .filter((input) => input.amount)
          .map((input) => parseInt(input.amount.toString().replaceAll('.', '')))
          .reduce((prev, curr) => (prev += curr))
      },
      deep: true
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() &&
      this.type !== '' &&
      this.paidTo !== '' &&
      this.date !== ''  &&
      this.amount !== null
    }
  },
  methods: {
    goBack () {
      if (this.hasPreviousRoute) {
        this.$router.go(-1)
        return
      }

      const cashbookId = this.cashbook_id || this.$route.query.cashbookId
      if (cashbookId) {
        this.$router.replace({
          name: 'cash-book-cashflows',
          params: {
            cashbookType: this.$route.params.cashbookType,
            cashbookId
          }
        })
        return
      }

      this.$router.replace({
        name: 'cash-book',
        params: { cashbookType: this.$route.params.cashbookType }
      })
    },
    add () {
      this.inputs.push({
        title: null,
        amount: '0'
      })
    },
    amountChange (index) {
      function processNumber (inputString) {
        // Remove leading zeros
        const trimmedString = inputString.replace(/^0+/, '')

        // Convert the string to a number
        let resultNumber = parseInt(trimmedString, 10)

        // Ensure the result is greater than 1
        resultNumber = Math.max(resultNumber, 1)

        return resultNumber
      }

      const splitamount = this.inputs[index].amount.split('')

      if (splitamount[0] === '0') {
        this.inputs[index].amount = processNumber(this.inputs[index].amount)
      }

      if (this.inputs[index].amount === null || this.inputs[index].amount === undefined || this.inputs[index].amount === '') {
        this.inputs[index].amount = '0'
      }

    },
    remove (index) {
      this.inputs.splice(index, 1)
    },
    findCashFlow () {
      const self      = this

      this.$store.dispatch('cashFlow/findCashFlow', self.$route.params.id)
        .then(res => {

          const data        = res.data.data

          self.cashbook_id  = data.cashbook_id
          self.type         = data.type
          self.paidTo       = data.paid_to
          self.number       = data.number
          self.date         = data.date
          self.notes        = data.notes

          self.inputs       = []
          data.items.forEach((value) => {
            self.inputs.push({
              title  : value.title,
              amount : value.amount
            })
          })

          if (data.type === 'debit') {
            self.amount = data.debit
          } else {
            self.amount = data.credit
          }

          self.loading = false
        })
        .catch(err => {
          self.loading = false
          self.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err.response.data.message
          })
        })
    },
    saveCashFlow () {
      const self      = this

      this.$validator.validateAll().then(result => {
        if (result) {

          const number  = Math.floor(Math.random() * 900) + 100

          let debit   = 0
          let credit  = 0

          if (self.type === 'debit') {
            debit   = self.amount
            credit  = 0
          } else {
            debit   = 0
            credit  = self.amount
          }

          const formData = new FormData()
          formData.set('type', self.type)
          formData.set('paid_to', self.paidTo)
          formData.set('date', self.date)
          formData.set('number', number)
          formData.set('debit', debit)
          formData.set('credit', credit)
          formData.set('notes', self.notes)
          formData.append(
            'items',
            JSON.stringify(
              self.inputs.map((input) => {
                input.amount = input.amount.toString().replaceAll('.', '')
                return input
              })
            )
          )
          formData.append('_method', 'PUT')

          this.$store.dispatch('cashFlow/updateCashFlow', {
            id    : self.$route.params.id,
            data  : formData
          })
            .then(function () {
              self.$vs.notify({
                color: 'success',
                title: 'Berhasil',
                text: 'Buku Kas berhasil di perbarui'
              })
              self.$router.push({ name: 'cash-book-cashflows', params: { cashbookType: self.$route.params.cashbookType, cashbookId: self.cashbook_id } })
            })
            .catch(err => {
              self.$vs.notify({
                color: 'danger',
                title: 'Opps..',
                text: err.data.message
              })
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .divider {
    background: #E0E0E0;
    height: 1px;
  }
</style>
